import { ReactNode } from 'react';
import { Skeleton, Empty, Sidebar } from '@treams/treams-ui';

type Props = {
	message: string;
	icon: ReactNode;
};

export const CollectiveGoalsSidebarSkeleton = ({ message, icon }: Props) => {
	return (
		<Skeleton.Empty contents={<Empty description={message} icon={icon} />}>
			<Skeleton.Repeat count={2}>
				<Sidebar.Item.Skeleton />
			</Skeleton.Repeat>
		</Skeleton.Empty>
	);
};
